import { get } from './axios'

//////////////////////////////////////////////////////////////////////
// GET
//////////////////////////////////////////////////////////////////////

/**
 * searchDormitory
 */

export type SearchDormitoryParams = {
  buildingName: string
  roomName: string
}

type SearchDormitoryResponseData = {
  buildingId: number
  roomId: number
}

export const searchDormitory = async (params: SearchDormitoryParams) => {
  return await get<SearchDormitoryResponseData>('/v1/buildings/searchDormitory', params, false)
}
